import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useAppDispatch } from '@/redux';
import { loadPaymentProvider } from '@/redux/thunks/checkout/loadPaymentProvider';
import { isPrimeurInCart } from '../../../utils/productUtils';

export const PayModeItem = ({ item: { description, descriptionWithPrimeur }, cart }) => {
  const dispatch = useAppDispatch();
  const paymentProviderAction = cart.content?.paiementMode?.action || 'NO_VALIDATION';

  useEffect(() => {
    dispatch(loadPaymentProvider({ paymentProvider: paymentProviderAction }));
  }, []);

  return (
    <div className="row box" data-test-id="paymode-item">
      <div
        className="col description"
        data-test-id="paymode-description"
        dangerouslySetInnerHTML={
          { __html: (isPrimeurInCart(cart) && descriptionWithPrimeur) ? descriptionWithPrimeur : description }
        }
      />
    </div>
  );
};

PayModeItem.propTypes = {
  item: PropTypes.shape({
    description: PropTypes.string.isRequired,
    descriptionWithPrimeur: PropTypes.string
  }).isRequired,
  cart: PropTypes.object
};

export default PayModeItem;
